import React, {useState, useEffect, useRef} from 'react';
import './styles.css';
import 'react-multi-carousel/lib/styles.css';
import Footer from '../../components/Footer';
import { useNavigate } from 'react-router-dom';

import SHADES from '../../images/homepage/shadesNews.png';
import TESLA from '../../images/homepage/tesla.png';
import AIRBNB from '../../images/homepage/airbnb.png';
import AMAZON from '../../images/homepage/amazon.png';
import APPLE from '../../images/homepage/apple.png';
import CHASE from '../../images/homepage/chase.png';
import CNBC from '../../images/homepage/cnbc.png';
import FIGMA from '../../images/homepage/figma.png';
import GOLDMANSACHS from '../../images/homepage/goldmansachs.png';
import KAISER from '../../images/homepage/kaiserPermanente.png';
import DELTA from '../../images/homepage/deltaAirlines.png';
import HCAHEALTH from '../../images/homepage/hcaHealth.png';
import GOOGLE from '../../images/homepage/google.png';
import JNJ from '../../images/homepage/jnj.png';
import KPMG from '../../images/homepage/kpmg.png';
import LOCKHEEDMARTIN from '../../images/homepage/lockheedmartin.png';
import META from '../../images/homepage/meta.png';
import NVIDIA from '../../images/homepage/nvidia.png';
import ROBINHOOD from '../../images/homepage/robinhood.png';
import STRIPE from '../../images/homepage/stripe.png';
import TIKTOK from '../../images/homepage/tiktok.png';
import WALMART from '../../images/homepage/walmart.png';
import NoraHomepage from '../../images/homepage/nora-homepage.png';

import NoraFeatures1 from '../../images/homepage/norafeatures1.png';
import NoraFeatures2 from '../../images/homepage/norafeatures2.png';
import NoraFeatures3 from '../../images/homepage/norafeatures3.png';
import NoraFeatures4 from '../../images/homepage/norafeatures4.png';

import 'swiper/swiper-bundle.css';
import 'swiper/css/pagination';
import SwiperCore from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import { useMediaQuery } from '@mui/material';

import Review5 from "../../images/homepage/review5.png";
import Review6 from "../../images/homepage/review6.png";
import Review7 from "../../images/homepage/review7.png";
import Review8 from "../../images/homepage/review8.png";
import Review9 from "../../images/homepage/review9.png";
import Review11 from "../../images/homepage/review11.png";
import Review17 from "../../images/homepage/review17.png";
import Container from "../../images/homepage/container.png";
import ContainerMobile from "../../images/homepage/containerMobile.png";

import CompanyCards from '../../components/CompanyCards';
import SEO from '../../components/SEO';
import { generateServiceSchema, generateSoftwareApplicationSchema, generateFAQSchema } from '../../utils/schemaGenerator';
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";

SwiperCore.use([Pagination]);

function Homepage({ loginState }) {
    let navigate = useNavigate();
    const isMobile = useMediaQuery('(max-width:600px)');

    const [loading, setLoading] = useState(false);
    const { referrerId, name } = useParams();

    const roles = ['Nursing', 'SWE', 'Legal', 'Marketing', 'Sales', 'Product', 'Retail'];
    const [roleIndex, setRoleIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setRoleIndex(prev => (prev + 1) % roles.length);
        }, 2000);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (referrerId) {
            localStorage.setItem("userReferred", "true");
            localStorage.setItem("referredBy", referrerId);
            localStorage.setItem("referrerId", referrerId);
            localStorage.setItem("referralSource", "Friend Referral");
        }
        }, [referrerId]);

    const [openIndex, setOpenIndex] = useState(null);
    const faqRefs = useRef([]);

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    useEffect(() => {
        const isMobile = window.innerWidth <= 600;
        faqRefs.current.forEach((ref, idx) => {
            if (ref) {
                if (openIndex === idx) {
                    const contentHeight = ref.scrollHeight;
                    ref.style.maxHeight = `${contentHeight}px`;
                    
                    if (isMobile) {
                        const basePadding = 165;
                        const extraPadding = Math.min(contentHeight * 0.1, 100);
                        const totalPadding = basePadding + extraPadding;
                        ref.style.padding = `0 20px ${totalPadding}px`;
                    } else {
                        ref.style.padding = '0 20px 70px';
                    }
                } else {
                    ref.style.maxHeight = '0';
                    ref.style.padding = '0 20px';
                }
            }
        });
    }, [openIndex]);
    
    const faqs = [
        {
            question: "Can Nora help me improve specific skills, like communication or technical knowledge?",
            answer: "Yes! Nora's got you covered. Whether it's technical know-how, communication skills, or overall interview performance, Nora gives you feedback on where you can improve and offers tips to help you level up."
        },
        {
            question: "Does Nora handle non-native speakers or users with accents?",
            answer: "Nora is designed to understand a variety of accents and speech patterns - you'll have an awesome experience regardless :)"
        },
        {
            question: "Can I track my progress and compare different interview sessions?",
            answer: "Yep, you sure can! Nora lets you look back at each mock interview, track your progress, and compare how you've done over time. It's a great way to see what's improving and what might still need some work."
        },
        {
            question: "Does Nora provide questions for both technical and non-technical roles?",
            answer: "Nora's got questions for all kinds of roles, whether you're going for something technical or more on the non-tech side. You can also toggle how technical or behavioral you want the interview to be. "
        },
        {
            question: "How much does Nora cost?",
            answer: "First mock interview & feedback is free. After that, it's $15/month for unlimited mock interviews and feedback!"
        }
    ];

    const [isVisible, setIsVisible] = useState(false);
    const [scrollProgress, setScrollProgress] = useState(0);

    useEffect(() => {
        const toggleVisibility = () => {
            const scrolled = document.documentElement.scrollTop;
            const maxHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
            const scrollPercentage = (scrolled / maxHeight) * 100;
        
            if (scrolled > 300) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
            setScrollProgress(scrollPercentage);
        };
    
        window.addEventListener('scroll', toggleVisibility);
        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

    const serviceSchema = generateServiceSchema();
    const softwareSchema = generateSoftwareApplicationSchema();
    const faqSchema = generateFAQSchema(faqs);

    return (
        <>
        <Helmet>
            <title>Nora AI</title>
            <meta name="description" content="The future of Interviewing" />
            <meta name="keywords" content="AI mock interview, interview practice, technical interview prep, behavioral interview, salary negotiation, job interview simulator, interview preparation, mock interview platform" />
            <link rel="canonical" href="https://interview.norahq.com" />

            {/* Open Graph */}
            <meta property="og:title" content="Nora AI" />
            <meta property="og:description" content="The future of Interviewing" />
            <meta property="og:type" content="website" />
            <meta property="og:url" content="https://interview.norahq.com" />
            <meta property="og:image" content="https://interview.norahq.com/images/logo/nora-ai-logo.png" />

            {/* Organization Schema */}
            <script type="application/ld+json">{JSON.stringify({
                "@context": "https://schema.org",
                "@type": "Organization",
                "name": "Nora AI",
                "url": "https://interview.norahq.com",
                "logo": "https://interview.norahq.com/images/logo/nora-ai-logo.png",
                "description": "AI mock interviewer helping job seekers practice technical, behavioral, and salary negotiation interviews",
                "sameAs": [
                "https://www.linkedin.com/company/norahq",
                "https://www.instagram.com/trynorahq/",
                "https://www.tiktok.com/@norahq"
                ]
            })}</script>

            {/* Website Schema */}
            <script type="application/ld+json">{JSON.stringify({
                "@context": "https://schema.org",
                "@type": "WebSite",
                "name": "Nora AI",
                "url": "https://interview.norahq.com",
                "description": "AI-powered mock interview platform for job interview preparation",
                "potentialAction": {
                "@type": "SearchAction",
                "target": "https://interview.norahq.com/search?q={search_term_string}",
                "query-input": "required name=search_term_string"
                }
            })}</script>

            {/* SoftwareApplication Schema */}
            <script type="application/ld+json">{JSON.stringify({
                "@context": "https://schema.org",
                "@type": "SoftwareApplication",
                "name": "Nora AI",
                "description": "AI-powered interview preparation platform with mock interviews and feedback",
                "url": "https://interview.norahq.com",
                "applicationCategory": "Educational Software",
                "operatingSystem": "Web Browser",
                "offers": {
                "@type": "Offer",
                "price": "15",
                "priceCurrency": "USD",
                "availability": "https://schema.org/InStock"
                }
            })}</script>

            {/* Service Schema */}
            <script type="application/ld+json">{JSON.stringify({
                "@context": "https://schema.org",
                "@type": "Service",
                "name": "Nora AI Mock Interviewer",
                "description": "AI mock interview platform with technical, behavioral, and salary negotiation practice. Get personalized feedback and land your dream job.",
                "provider": {
                "@type": "Organization",
                "name": "Nora AI"
                },
                "serviceType": "Interview Preparation",
                "offers": {
                "@type": "Offer",
                "availability": "https://schema.org/InStock",
                "price": "0",
                "priceCurrency": "USD"
                }
            })}</script>
        </Helmet>
        <div className='homepage'>
            {loading && (
                <div className="loader3">
                    <div className="loader2"></div>
                </div>
            )}

            {/* ── HERO SECTION ── */}
            <div className={isMobile ? "landing landing-mobile" : "landing"}>
                <div className="left-container">
                    <div className="badge-pill">
                        <span className="badge-plus">+</span> The #1 AI Mock Interviewer
                    </div>

                    <h1>
                        {name ? (
                            <>
                            {decodeURIComponent(name).replace(/^\w/, c => c.toUpperCase())}, sent you a free mock interview 🎉
                            </>
                        ) : (
                            <>
                            Practice Interviews
                            <br />
                            for <span className="rotating-role">{roles[roleIndex]}</span>
                            </>
                        )}
                    </h1>

                    <p>
                        Interview coming up? Sharpen your skills with AI-powered interview sessions and personalized feedback for any role.
                    </p>

                    {!loginState.loggedIn && (
                        <button
                            className="nora-landing-cta"
                            onClick={() => name
                                ? navigate("/login", {
                                    state: {
                                        referredFrom: referrerId || null,
                                        userReferred: true
                                    }
                                })
                                : navigate("/login")
                            }
                        >
                            {name ? "Practice with Nora Mock Interviewer" : "Practice with Nora Mock Interviewer"} &nbsp;→
                        </button>
                    )}

                    <div className="social-proof">
                        <div className="social-proof-row">
                            <div className="avatar-group">
                                <img src={Review5} alt="user" className="avatar-img" />
                                <img src={Review6} alt="user" className="avatar-img" />
                                <img src={Review7} alt="user" className="avatar-img" />
                                <img src={Review8} alt="user" className="avatar-img" />
                            </div>
                            <span className="social-proof-text">
                                Join <strong>10,800+</strong> candidates practicing
                            </span>
                        </div>
                        <a href="https://www.norahq.com" className="social-proof-link">
                            Hiring team? See AI Screening
                        </a>
                    </div>
                </div>

                {!isMobile && (
                    <div className="right-container">
                        <img
                            src={NoraHomepage}
                            alt="Nora AI Mock Interviewer in action"
                            className="hero-image"
                        />
                    </div>
                )}
            </div>

            {/* Mobile-only hero image */}
            {isMobile && (
                <div style={{ display: 'flex', justifyContent: 'center', padding: '20px 16px 0' }}>
                    <img
                        src={NoraHomepage}
                        alt="Nora AI Mock Interviewer in action"
                        style={{ maxWidth: '95%' }}
                    />
                </div>
            )}

            {/* Logo slider */}
            <div className="logo-slider">
                {/* <h2 className="companies-header">Companies Our Users Have Received Offers From</h2> */}
                <p className="companies-header">
                    Companies Our Users Have Received Offers From
                </p>
                <div className="logo-track">
                    {[...Array(2)].map(() => (
                        <>
                            <div className="logo-item">
                                <img src={AIRBNB} alt="Airbnb" />
                            </div>
                            <div className="logo-item">
                                <img src={AMAZON} alt="Amazon" />
                            </div>
                            <div className="logo-item">
                                <img src={TESLA} alt="Tesla" />
                            </div>
                            <div className="logo-item">
                                <img src={APPLE} alt="Apple" />
                            </div>
                            <div className="logo-item">
                                <img src={CHASE} alt="Chase" />
                            </div>
                            <div className="logo-item">
                                <img src={GOLDMANSACHS} alt="Goldman Sachs" />
                            </div>
                            <div className="logo-item">
                                <img src={CNBC} alt="CNBC" />
                            </div>
                            <div className="logo-item">
                                <img src={FIGMA} alt="Figma" />
                            </div>
                            <div className="logo-item">
                                <img src={NVIDIA} alt="NVIDIA" />
                            </div>
                            <div className="logo-item">
                                <img src={JNJ} alt="Johnsons & Johnson" />
                            </div>
                            <div className="logo-item">
                                <img src={HCAHEALTH} alt="HCA Health" />
                            </div>
                            <div className="logo-item">
                                <img src={GOOGLE} alt="Google" />
                            </div>
                            <div className="logo-item">
                                <img src={DELTA} alt="Delta Airlines" />
                            </div>
                            <div className="logo-item">
                                <img src={META} alt="Meta" />
                            </div>
                            <div className="logo-item">
                                <img src={TIKTOK} alt="TikTok" />
                            </div>
                            <div className="logo-item">
                                <img src={STRIPE} alt="Stripe" />
                            </div>
                            <div className="logo-item">
                                <img src={KPMG} alt="KPMG" />
                            </div>
                            <div className="logo-item">
                                <img src={KAISER} alt="kaiser" />
                            </div>
                            <div className="logo-item">
                                <img src={WALMART} alt="Walmart" />
                            </div>
                        </>
                    ))}
                </div>
            </div>

            <div className="outsourcing-solution" id="how-it-works">
                <h2 className="outsourcing-heading">How Nora Works - <span style={{ color: '#7D994D' }}> It's Simple. </span> </h2>
                <p className="outsourcing-description">
                    3 simple steps to level up your interview game
                </p>
            </div>

            <div className="how-it-works-1-partnership">
                <img src={isMobile ? ContainerMobile : Container} alt="Feedback" id="feedback-picture" className='image2-styling' />
            </div>

            <div className="outsourcing-solution">
                <h2 className="outsourcing-heading">Watch Nora in Real Time</h2>
                <p className="outsourcing-description" style={{ marginBottom: '50px' }}>
                    Watch how Nora works in real life, and can offer valuable interview practice.
                </p>
                <iframe
                    width={isMobile ? "380" : "640"}
                    height={isMobile ? "214" : "360"}
                    src="https://www.youtube.com/embed/7u0Rf3D_jN0?si=wlmJwsxo5_QjGrrl"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen>
                </iframe>
            </div>

            <div className="outsourcing-solution" id="how-it-works" style={{ marginTop: isMobile ? '30%' : '7%' }}>
                <h2 className="outsourcing-heading">The last <span style={{ color: '#7D994D' }}> Mock Interview </span> you'll ever need </h2>
                <p className="outsourcing-description">
                    Real company questions, a mock interview that actually feels like the real thing, and feedback that doesn't sugarcoat
                </p>
            </div>

            <div className="features-grid-section">
                <div className="features-grid">
                    <div className="feature-card">
                        <img src={NoraFeatures1} alt="Real Interview Questions" className="feature-card-img" />
                        <div className="feature-card-body">
                            <h3>Real Questions from the Real World</h3>
                            <p>We simulate reality by sourcing the latest questions from across the internet and our vetted database.</p>
                        </div>
                    </div>
                    <div className="feature-card">
                        <img src={NoraFeatures2} alt="AI Feedback" className="feature-card-img" />
                        <div className="feature-card-body">
                            <h3>Extremely Realistic Voice Interaction</h3>
                            <p>"Everything is answered through voice... it really feels like you're interviewing with the recruiter."</p>
                        </div>
                    </div>
                    <div className="feature-card">
                        <img src={NoraFeatures3} alt="Any Role" className="feature-card-img" />
                        <div className="feature-card-body">
                            <h3>No Cap, Here's How You Did</h3>
                            <p>See your mock interview score, your skills gaps, and chat with Nora to level up fast.</p>
                        </div>
                    </div>
                    <div className="feature-card">
                        <img src={NoraFeatures4} alt="Track Progress" className="feature-card-img" />
                        <div className="feature-card-body">
                            <h3>Tailored Modes for Every Need</h3>
                            <p>Choose the specific type of interview practice you need today.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="cool-homepage-section">
                <h2 className="outsourcing-heading">"This feels like having the interview questions a day before."</h2>
                {!loginState.loggedIn && (
                    <div className="button-container">
                        <button className="nora-button-style"
                            style={{ marginTop: '10px' }}
                            onClick={() => name
                                ? navigate("/login", { state: { referredFrom: referrerId || null, userReferred: true } })
                                : navigate("/login")
                            }>
                            And the interview answers.
                        </button>
                    </div>
                )}
            </div>

            <div className="cta-container" id="testimonials">
                <div className="cta-text">Hear from Applicants like you</div>
            </div>
            <div>
                <Swiper
                    spaceBetween={0}
                    slidesPerView={isMobile ? 1 : 3}
                    modules={[Pagination]}
                    pagination={{ clickable: true }}
                    style={{ margin: 'auto', paddingBottom: '70px', paddingTop: '20px' }}
                >
                    <SwiperSlide>
                        <div className="card">
                            <div className="card-top">
                                <img
                                    src={Review5}
                                    alt="Samantha Chou Photo"
                                    className="card-image-styling" />
                            </div>
                            <div className="card-content">
                                <h3>Samantha Chou</h3>
                                <p className="title">PM Intern at Amazon</p>
                                <p className="quote">
                                    "Nora is a helpful and easy-to-use mock interview tool.
                                    Love the interactive nature and the question-by-question feedback and analysis!
                                    Very useful in the job searching process!"
                                </p>
                            </div>
                        </div>
                    </SwiperSlide>

                    <SwiperSlide>
                        <div className="card">
                            <div className="card-top">
                                <img
                                    src={Review17}
                                    alt="Tey Jon Paul Photo"
                                    className="card-image-styling" />
                            </div>
                            <div className="card-content">
                                <h3>Tey Jon P.</h3>
                                <p className="title">Registered Nurse, Providence</p>
                                <p className="quote">
                                    "I've always been good at the clinical stuff but the interview part terrified me. 
                                    Practicing with Nora made it feel like just another skill I could actually get better at"
                                </p>
                            </div>
                        </div>
                    </SwiperSlide>

                    <SwiperSlide>
                        <div className="card">
                            <div className="card-top">
                                <img
                                    src={Review8}
                                    alt="Julia Son Photo"
                                    className="card-image-styling" />
                            </div>
                            <div className="card-content">
                                <h3>Julia Son</h3>
                                <p className="title">Marketing at Meta</p>
                                <p className="quote">
                                    "Easily the best way to prepare for an interview.
                                    With constructive, personalized feedback, I'd recommend Nora to anybody looking to
                                    prepare for any upcoming interviews. Such a great resource!"
                                </p>
                            </div>
                        </div>
                    </SwiperSlide>

                    <SwiperSlide>
                        <div className="card">
                            <div className="card-top">
                                <img
                                    src={Review11}
                                    alt="Ali S Photo"
                                    className="card-image-styling" />
                            </div>
                            <div className="card-content">
                                <h3>Ali S.</h3>
                                <p className="title">Cabin Crew, Emirates</p>
                                <p className="quote">
                                    "What surprised me was how real it felt. 
                                    It was like an actual back and forth conversation 
                                    like a real recruiter was sitting across from me. Really cool product!"
                                </p>
                            </div>
                        </div>
                    </SwiperSlide>

                    <SwiperSlide>
                        <div className="card">
                            <div className="card-top">
                                <img
                                    src={Review6}
                                    alt="Carissa Wu Photo"
                                    className="card-image-styling" />
                            </div>
                            <div className="card-content">
                                <h3>Carissa Wu</h3>
                                <p className="title">Computer Engineering, Senior</p>
                                <p className="quote">
                                    "Great tool that simulates real life interviews.
                                    I used it to practice for a web developer position,
                                    and the questions Nora asked were what my interviewer asked me."
                                </p>
                            </div>
                        </div>
                    </SwiperSlide>

                    <SwiperSlide>
                        <div className="card">
                            <div className="card-top">
                                <img
                                    src={Review9}
                                    alt="Sydney Nguyen Photo"
                                    className="card-image-styling" />
                            </div>
                            <div className="card-content">
                                <h3>Sydney Nguyen</h3>
                                <p className="title">Sales, Senior at UCR</p>
                                <p className="quote">
                                    "Nora is super helpful and gives realistic questions.
                                    I love the specific focus on information provided from your resume - it's especially helpful for creative positions
                                    that require a wide variety of skills. 100% recommend!"
                                </p>
                            </div>
                        </div>
                    </SwiperSlide>
                </Swiper>

            </div>

            {/* FAQ Section */}
            <div className="faq-section" id="faqs">
                <h2 style={{
                    fontSize: '32px',
                    marginBottom: '25px',
                    fontWeight: '500',
                    fontFamily: "'Lateef', serif",
                    textAlign: 'center'
                }}> Frequently <span style={{ color: '#7D994D' }}> Asked Questions </span> </h2>
                {faqs.map((faq, index) => (
                    <div className="faq-item" key={index}>
                        <button
                            className="faq-question"
                            onClick={() => toggleFAQ(index)}
                        >
                            {faq.question}
                            <span className="arrow">{openIndex === index ? '▼' : '▲'}</span>
                        </button>
                        <div
                            className="faq-answer"
                            ref={el => faqRefs.current[index] = el}
                        >
                            {faq.answer}
                        </div>
                    </div>
                ))}
            </div>

            {/* Company Mock Interview Section */}
            <div>
                <h2 className="company-mock-section-section">Jump start your interview practice now.</h2>
                <CompanyCards />
            </div>

            <div className={isMobile ? "practiceNoraCard-mobile" : "practiceNoraCard"}>
                <div style={{ textAlign: "center" }}>
                    <div className={isMobile ? "practiceNoraCardHead-mobile" : "practiceNoraCardHead"}>Ready to begin mastering interviews with Nora?</div>

                    <button className="nora-button-style"
                        onClick={() => name
                            ? navigate("/login", { state: { referredFrom: referrerId || null, userReferred: true } })
                            : navigate("/login")
                        }>
                        Practice Now
                    </button>
                </div>
            </div>

            <Footer />
        </div>
    </>
    )
}

export default Homepage;